(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode(".vue-waterfall{width:100%;overflow-y:auto;position:relative}.vue-waterfall .slot-box{position:absolute;top:100%;left:100%;width:0;height:0;overflow:hidden}.vue-waterfall .vue-waterfall-column{float:left}.vue-waterfall.is-transition img{opacity:0}.vue-waterfall.is-transition img.animation{-webkit-animation:.4s lazy-animation linear;animation:.4s lazy-animation linear;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@-webkit-keyframes lazy-animation{0%{opacity:0}to{opacity:1}}@keyframes lazy-animation{0%{opacity:0}to{opacity:1}}")),document.head.appendChild(a)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import e from "./bus.es.js";
import r from "./waterfall.vue.es.js";
var n = {
  install: function(t) {
    this.installed || (this.installed = !0, t.component("waterfall", r), t.prototype.$waterfall = {
      forceUpdate: function() {
        e.emit("forceUpdate");
      },
      mix: function() {
        e.emit("mix");
      }
    });
  }
};
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-waterfall2/dist/index.es.js
// module id = null
// module chunks = 